import React, { useEffect, useState, useRef } from "react";
import { onAuthStateChanged, signOut } from "firebase/auth";
import { auth } from "../Firebase/firestore";
import { useNavigate, useLocation } from "react-router-dom";

const SessionExpiredWrapper = ({ children }) => {
  const [isCheckingAuth, setIsCheckingAuth] = useState(true);
  const [showSessionExpired, setShowSessionExpired] = useState(false);
  const [isOffline, setIsOffline] = useState(false);
  const wasLoggedInRef = useRef(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const unsubscribeAuth = onAuthStateChanged(auth, (user) => {
      if (user) {
        wasLoggedInRef.current = true;
        setIsCheckingAuth(false);
      } else {
        if (
  wasLoggedInRef.current &&
  location.pathname !== "/login"
) {
  setShowSessionExpired(true);
}
        setIsCheckingAuth(false);
      }
    });

    // Network event listeners
    const handleOffline = () => setIsOffline(true);
    const handleOnline = () => setIsOffline(false);

    window.addEventListener("offline", handleOffline);
    window.addEventListener("online", handleOnline);

    return () => {
      unsubscribeAuth();
      window.removeEventListener("offline", handleOffline);
      window.removeEventListener("online", handleOnline);
    };
  }, [location.pathname, navigate]);

  const handleSessionExpiredOK = async () => {
    setShowSessionExpired(false);
    await signOut(auth);
    navigate("/login");
  };

  return (
    <>
      {!isCheckingAuth && children}

      {/* Session Expired Popup */}
      {showSessionExpired && (
        <div style={popupOverlayStyle}>
          <div style={popupContentStyle}>
            <p>Your session has expired. Please log in again.</p>
            <button onClick={handleSessionExpiredOK}>OK</button>
          </div>
        </div>
      )}

      {/* Network Offline Popup */}
      {isOffline && (
        <div style={popupOverlayStyle}>
          <div style={popupContentStyle}>
            <p>You are currently offline. Please check your internet connection.</p>
            <button onClick={() => setIsOffline(false)}>OK</button>
          </div>
        </div>
      )}
    </>
  );
};

// Styles for the modals
const popupOverlayStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  height: "100vh",
  width: "100vw",
  backgroundColor: "rgba(0,0,0,0.6)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 9999,
};

const popupContentStyle = {
  backgroundColor: "#fff",
  padding: 20,
  borderRadius: 10,
  textAlign: "center",
  minWidth: "300px",
};

export default SessionExpiredWrapper;
